import { createSelector } from '@reduxjs/toolkit';
import { RootState } from 'src/store';
import { ClientFormInput, SimpleSelectData } from 'src/types';
import {
  InStoreAgencyInfo,
  InStoreAgencyState,
  InStoreClientRequestForm,
  InStoreSubmitDataState,
  SuccessInStoreSubmit,
} from '../InStore.types';

export const inStoreAgencyExistSelector = (state: RootState): boolean => {
  return !!state.inStore.agency.info;
};

export const inStoreAgencyState = (state: RootState): InStoreAgencyState => {
  return state.inStore.agency;
};

export const inStoreAgencyInfoSelector = (state: RootState): InStoreAgencyInfo | null => {
  return state.inStore.agency.info;
};

export const inStoreFormSenderSelector = (state: RootState): ClientFormInput => {
  return state.inStore.form.sender;
};

export const inStoreFormReceiverSelector = (state: RootState): ClientFormInput | null => {
  return state.inStore.form.receiver;
};

export const inStoreFormToAgencySelector = (state: RootState): string => {
  return state.inStore.form.toAgency;
};

export const esStoreAgencyNameSelector = createSelector(
  inStoreAgencyInfoSelector,
  (info: InStoreAgencyInfo | null): string => {
    return info?.name ?? '';
  },
);

export const inStoreAgenciesSelector = (state: RootState): InStoreAgencyInfo[] => {
  return state.inStore.agency.agencies;
};

export const inStoreSenderIsNotReceiverSelector = (state: RootState): boolean => {
  return state.inStore.form.senderIsNotReceiver;
};

export const inStoreFormStateSelector = (state: RootState): InStoreClientRequestForm => {
  return state.inStore.form;
};

export const inStoreSubmitDataIsLoadingSelector = (state: RootState): boolean => {
  return state.inStore.submitData.isLoading;
};

export const inStoreSubmitDataErrorSelector = (state: RootState): Error | null => {
  return state.inStore.submitData.error;
};

export const inStoreSubmitDataSuccessSelector = (state: RootState): SuccessInStoreSubmit | null => {
  return state.inStore.submitData.success;
};

export const inStoreSubmitDataStateSelector = (state: RootState): InStoreSubmitDataState => {
  return state.inStore.submitData;
};

export const inStoreAgenciesForSelectSelector = createSelector(
  inStoreAgenciesSelector,
  (agencies): SimpleSelectData => {
    return agencies.map((agency) => ({ label: agency.name, value: agency.slug }));
  },
);
